module.exports = __webpack_public_path__ + "static/img/092_TO8_1759.c9045ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/092_TO8_1759.jpg
// module id = 0HeL
// module chunks = 0